export function generateConnectorPath(
  startX: number,
  startY: number,
  endX: number,
  endY: number
): string {
  const midY = startY + (endY - startY) / 2;
  return `M ${startX} ${startY} L ${startX} ${midY} L ${endX} ${midY} L ${endX} ${endY}`;
}